// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__AuYDy","light":"style_light__WVY2m","dark":"style_dark__QFNEN","thumb":"style_thumb__15ldr","button":"style_button__Xocv7"};